export default "__VITE_ASSET__DfnrUirE__"